import React, { useState, useEffect } from 'react';
import {
  Paper,
  Tooltip,
  IconButton,
  InputAdornment,
  TextField,
} from '@material-ui/core';
import PromotionTable from './components/DataTable/PromotionTable';
import ActionForm from './components/ActionForm/ActionForm';
import PromotionDetail from './components/PromotionDetail/PromotionDetail';
import newButton from '../../assets/img/iconos/newButton.svg';
import searchIcon from '../../assets/img/iconos/searchIcon.svg';
import reload from '../../assets/img/iconos/reload.svg';
import {
  getPromotionService,
} from '../../services';
import { Loading, Toaster } from '../../components';
import useStyle from './useStyle';

const PromotionsScreen = () => {
  const classes = useStyle();
  const [promotions, setPromotions] = useState([]);
  const [loading, setLoading] = useState(false);
  const defaultData = {
    file: null,
    fileName: '',
    eventName: '',
    registers: 0,
    totalAmount: 0,
  };
  const [enteredFilter, setEnteredFilter] = useState('');
  const [defaultValues, setDefaultValues] = useState(defaultData);
  const [popUpAction, setPopUpAction] = useState({ open: false, title: '', data: null });
  const [popUpActionDetail, setPopUpActionDetail] = useState({
    open: false, title: '', data: null, link: '', fileName: '', status: '', users: null, amount: null,
  });
  const [alert, setAlert] = useState({ status: false, type: '', message: '' });

  const getPromotions = async () => {
    if (promotions.length === 0) {
      setLoading(true);
    }
    try {
      const res = await getPromotionService();
      if (res.status >= 300) {
        setAlert({ status: true, type: 'error', message: 'Ha ocurrido un error al cargar el historial de promociones.' });
      } else {
        setPromotions(res?.data.summary);
      }
    } catch (e) {
      setAlert({ status: true, type: 'error', message: 'Ha ocurrido un error al cargar el historial de promociones.' });
    }
    setLoading(false);
  };

  const getPromotionsRefresh = async () => {
    setLoading(true);
    try {
      const res = await getPromotionService();
      if (res.status >= 300) {
        setAlert({ status: true, type: 'error', message: 'Ha ocurrido un error al cargar el historial de promociones.' });
      } else {
        setPromotions(res?.data.summary);
        setAlert({ status: true, type: 'info', message: 'Las promociones se han actualizado' });
      }
    } catch (e) {
      setAlert({ status: true, type: 'error', message: 'Ha ocurrido un error al cargar el historial de promociones.' });
    }
    setLoading(false);
  };

  const createCsv = () => {
    setDefaultValues(defaultData);
    setPopUpAction({
      open: true,
      title: 'Cargar Promoción',
      data: null,
    });
  };

  const detailCsv = (link, fileName, status, users, amount) => {
    setPopUpActionDetail({
      open: true,
      data: null,
      title: 'Ver Promoción',
      link,
      fileName,
      status,
      users,
      amount,
    });
  };

  useEffect(() => {
    const run = async () => {
      await getPromotions();
    }

    run();
  }, []);

  return (

    <Paper className={classes.paper}>
      <>
        {loading && <Loading />}
        <div className={classes.root}>
          <div>
            <TextField
              className={classes.searchTextField}
              value={enteredFilter}
              onChange={(e) => setEnteredFilter(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={searchIcon} alt="searchIcon" style={{ paddingLeft: '10px' }} />
                  </InputAdornment>
                ),
                disableUnderline: true,
              }}
              placeholder="Buscar"
            />
            <Tooltip title="Refrescar página" aria-label="Refrescar página">
              <IconButton
                onClick={getPromotionsRefresh}
                style={{ fontSize: '20px', float: 'right' }}
                edge="end"
                size="small"
              >
                <img src={reload} alt="reload" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Cargar archivo csv" aria-label="Cargar archivo csv">
              <IconButton
                onClick={createCsv}
                style={{ fontSize: '20px', float: 'right' }}
                edge="end"
                size="small"
              >
                <img src={newButton} alt="newButton" />
              </IconButton>
            </Tooltip>
          </div>

          <PromotionTable
            promotions={promotions}
            setPromotions={setPromotions}
            detailCsv={detailCsv}
            setAlert={setAlert}
            enteredFilter={enteredFilter}
          />
          <ActionForm
            open={popUpAction.open}
            data={popUpAction.data}
            title={popUpAction.title}
            defaultValues={
              {
                ...defaultValues,
              }
            }
            getPromotions={getPromotions}
            onClose={() => {
              setPopUpAction({ open: false, title: '', data: null });
              setEnteredFilter('');
              setTimeout(() => {
                getPromotions();
              }, 3000);
            }}
            setAlertHome={setAlert}
          />
          <PromotionDetail
            open={popUpActionDetail.open}
            data={popUpActionDetail.data}
            title={popUpActionDetail.title}
            getPromotions={getPromotions}
            link={popUpActionDetail.link}
            fileName={popUpActionDetail.fileName}
            status={popUpActionDetail.status}
            users={popUpActionDetail.users}
            amount={popUpActionDetail.amount}
            setAlertHome={setAlert}
            onClose={() => {
              setPopUpActionDetail({
                open: false, title: '', data: null, link: '', fileName: '',
              });
            }}
            reloadPromotions={() => {
              setTimeout(() => {
                getPromotions();
              }, 3000);
            }}
          />
        </div>
        <Toaster
          show={alert.status}
          type={alert.type}
          text={alert.message}
          onClose={() => setAlert({ ...alert, status: false })}
        />
      </>
    </Paper>
  );
};

export default PromotionsScreen;
